(function () {
  if (window.__vitalizartB2BPageInitialized) return;
  window.__vitalizartB2BPageInitialized = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function formatCounter(value) {
    return Math.round(value).toLocaleString('en-US');
  }

  function animateCounter(element) {
    if (element.dataset.counterAnimated === 'true') return;
    element.dataset.counterAnimated = 'true';

    var target = Number(element.dataset.counterTarget || 0);
    var duration = Number(element.dataset.counterDuration || 900);
    var suffix = element.dataset.counterSuffix || '';

    if (!Number.isFinite(target) || reducedMotion.matches) return;

    var startTime;
    element.textContent = '0' + suffix;

    function tick(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      element.textContent = formatCounter(target * eased) + suffix;
      if (progress < 1) window.requestAnimationFrame(tick);
    }

    window.requestAnimationFrame(tick);
  }

  function prepareCounters(scope) {
    var counters = scope.querySelectorAll('[data-b2b-counter]:not([data-counter-ready])');
    if (!counters.length) return;

    counters.forEach(function (counter) {
      counter.dataset.counterReady = 'true';
      if (reducedMotion.matches || !('IntersectionObserver' in window)) {
        animateCounter(counter);
        return;
      }

      counter.textContent = '0' + (counter.dataset.counterSuffix || '');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          animateCounter(counter);
        });
      }, { threshold: 0.25 });
      observer.observe(counter.closest('.b2b-trust') || counter);
    });
  }

  function configureFaqItem(item) {
    if (item.dataset.b2bFaqReady === 'true') return;
    var summary = item.querySelector('.b2b-faq__summary');
    var answer = item.querySelector('.b2b-faq__answer-wrap');
    if (!summary || !answer) return;

    item.dataset.b2bFaqReady = 'true';

    function clearAnimationState() {
      item.classList.remove('is-animating', 'is-opening', 'is-closing');
      answer.style.removeProperty('height');
      answer.style.removeProperty('opacity');
    }

    function finishAnimation(isOpening) {
      if (!isOpening) item.open = false;
      clearAnimationState();
    }

    function animateFaq(isOpening) {
      if (reducedMotion.matches) {
        item.open = isOpening;
        clearAnimationState();
        return;
      }

      item.classList.add('is-animating', isOpening ? 'is-opening' : 'is-closing');

      if (isOpening) {
        item.open = true;
        answer.style.height = '0px';
        answer.style.opacity = '0';
      } else {
        answer.style.height = answer.getBoundingClientRect().height + 'px';
        answer.style.opacity = '1';
      }

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          answer.style.height = isOpening ? answer.scrollHeight + 'px' : '0px';
          answer.style.opacity = isOpening ? '1' : '0';
        });
      });

      var finished = false;
      function complete(event) {
        if (finished || (event && event.propertyName !== 'height')) return;
        finished = true;
        answer.removeEventListener('transitionend', complete);
        window.clearTimeout(fallbackTimer);
        finishAnimation(isOpening);
      }

      answer.addEventListener('transitionend', complete);
      var fallbackTimer = window.setTimeout(complete, 420);
    }

    summary.addEventListener('click', function (event) {
      event.preventDefault();
      if (item.classList.contains('is-animating')) return;
      animateFaq(!item.open);
    });
  }

  function prepareFaqs(scope) {
    if (scope.matches && scope.matches('[data-b2b-faq-item]')) configureFaqItem(scope);
    scope.querySelectorAll('[data-b2b-faq-item]').forEach(configureFaqItem);
  }

  function getJumpNavigationOffset() {
    var selectors = [
      'sticky-header',
      '.shopify-section-header-sticky',
      '.header-wrapper',
      '.site-header',
      '#shopify-section-header'
    ];
    var offset = 0;

    document.querySelectorAll(selectors.join(',')).forEach(function (header) {
      var style = window.getComputedStyle(header);
      if (style.position !== 'fixed' && style.position !== 'sticky') return;

      var rect = header.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top > 1) return;
      offset = Math.max(offset, rect.bottom);
    });

    return Math.max(16, Math.ceil(offset + 16));
  }

  function getJumpNavigationTarget(link) {
    var hash = link.getAttribute('href');
    if (!hash || hash.charAt(0) !== '#') return null;

    try {
      return document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (error) {
      return null;
    }
  }

  function configureJumpNavigation(nav) {
    if (nav.dataset.b2bAnchorReady === 'true') return;

    var links = Array.from(nav.querySelectorAll('[data-b2b-anchor-link]'));
    var entries = links.map(function (link) {
      return { link: link, target: getJumpNavigationTarget(link) };
    }).filter(function (entry) {
      return entry.target;
    });
    if (!entries.length) return;

    nav.dataset.b2bAnchorReady = 'true';

    function setCurrentLink(activeLink) {
      entries.forEach(function (entry) {
        if (entry.link === activeLink) {
          entry.link.setAttribute('aria-current', 'location');
        } else {
          entry.link.removeAttribute('aria-current');
        }
      });
    }

    function updateCurrentLink() {
      if (!nav.isConnected) {
        window.removeEventListener('scroll', queueCurrentLinkUpdate);
        window.removeEventListener('resize', queueCurrentLinkUpdate);
        return;
      }

      var marker = getJumpNavigationOffset() + 48;
      var activeEntry = null;

      entries.forEach(function (entry) {
        if (entry.target.getBoundingClientRect().top <= marker) activeEntry = entry;
      });

      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
        activeEntry = entries[entries.length - 1];
      }

      setCurrentLink(activeEntry ? activeEntry.link : null);
    }

    var updateQueued = false;
    function queueCurrentLinkUpdate() {
      if (updateQueued) return;
      updateQueued = true;
      window.requestAnimationFrame(function () {
        updateQueued = false;
        updateCurrentLink();
      });
    }

    entries.forEach(function (entry) {
      entry.link.addEventListener('click', function (event) {
        event.preventDefault();

        var targetTop = entry.target.getBoundingClientRect().top + window.scrollY - getJumpNavigationOffset();
        window.scrollTo({
          top: Math.max(0, targetTop),
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });

        setCurrentLink(entry.link);

        try {
          window.history.pushState(null, '', entry.link.getAttribute('href'));
        } catch (error) {
          window.location.hash = entry.link.getAttribute('href');
        }
      });
    });

    window.addEventListener('scroll', queueCurrentLinkUpdate, { passive: true });
    window.addEventListener('resize', queueCurrentLinkUpdate);
    updateCurrentLink();
  }

  function prepareJumpNavigations(scope) {
    if (scope.matches && scope.matches('[data-b2b-anchor-nav]')) configureJumpNavigation(scope);
    scope.querySelectorAll('[data-b2b-anchor-nav]').forEach(configureJumpNavigation);
  }

  function openQuoteForm() {
    var formBuilder = window.Globo && window.Globo.FormBuilder;
    var floatingTrigger = document.querySelector('.globo-formbuilder[data-id="156977"] .floating-button, .globo-form-id-156977 .floating-button, .floating-button[onclick*="Globo.FormBuilder.showFloatingForm"]');

    if (formBuilder && typeof formBuilder.showFloatingForm === 'function' && floatingTrigger) {
      formBuilder.showFloatingForm(floatingTrigger);
      return;
    }

    if (floatingTrigger) floatingTrigger.click();
  }

  function initialize(scope) {
    prepareCounters(scope);
    prepareFaqs(scope);
    prepareJumpNavigations(scope);
  }

  initialize(document);

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-b2b-open-quote-form]');
    if (!trigger) return;
    event.preventDefault();
    openQuoteForm();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
